import { createSelector } from '@reduxjs/toolkit';

import { selectEtazhiBlackFridayPricesData } from './selectEtazhiBlackFridayPricesData';
import { selectOfferId } from '../offerData/offer/selectOfferId';

export const selectEtazhiBlackFridayFullOfferPrice = createSelector(
  selectEtazhiBlackFridayPricesData,
  selectOfferId,
  (pricesData, offerId) => {
    if (!pricesData) {
      return null;
    }

    const priceByOfferId = pricesData[offerId];

    if (!priceByOfferId) {
      return null;
    }

    return priceByOfferId;
  },
);
